import React from "react";
import hoistNonReactStatics from "hoist-non-react-statics";

const withHook = (useHook) => (C) => {
	const HoC = (props) => {
		useHook(props);

		return <C {...props} />;
	};

	HoC.displayName = `withHook(${useHook.name})(${C.displayName || C.name})`;

	hoistNonReactStatics(HoC, C);

	return HoC;
};

export default withHook;
